import flow from 'lodash/flow';
import withProps from '@atlassian/jira-common-with-props/src/index.tsx';
import CreateDialogLoader from '@atlassian/jira-create-boards-button/src/view/create-dialog-loader/index.tsx';
import CreateButton from '@atlassian/jira-create-boards-button/src/view/stateless-button/index.tsx';
import { injectIntl } from '@atlassian/jira-intl';
import Empty from './view.tsx';

export default flow(
	injectIntl,
	withProps({
		CreateDialogLoader,
		CreateButton,
	}),
)(Empty);
